export const getUrlParam = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
};

/**
 * 获取URL参数
 * @param {*} url
 * @returns
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

export class Timers {
  static step() {
    return new Timers({}).step(cb);
  }

  constructor(options) {
    this.opt = {};
    this.startTime = 0;
    this.timer = null;
    const defOpt = {
      timer: null,
      startTime: 60,
    };
    this.opt = {
      ...defOpt,
      ...options,
    };
    this.startTime = this.opt.startTime;
    this.timer = null;
  }
  step(cb, once = true) {
    once && cb && cb(this.startTime);
    return new Promise((r) => {
      this.timer = setInterval(() => {
        this.startTime--;
        if (this.startTime > 0) {
          cb && cb(this.startTime);
        } else {
          r();
          this.timer && clearInterval(this.timer);
        }
      }, 1000);
    });
  }
  stop() {
    clearInterval(this.timer);
  }
}

/**
 *
*/

export const fetch_timeout = (fecthPromise, timeout = 5000) => {
  let abort = null;
  let abortPromise = new Promise((resolve, reject) => {
    abort = () => {
      return reject({
        code: 504,
        message: "请求超时！"
      });
    };
  });

  // 最快出结果的promise 作为结果
  let resultPromise = Promise.race([fecthPromise, abortPromise]);
  setTimeout(() => {
    abort();
  }, timeout);

  return resultPromise.then(res => {
      clearTimeout(timeout);
      return res;
   });
}
